import * as Yup from "yup";

export const financialStatementsSchema = Yup.object({
  financialStatements: Yup.object({
    lastFinancialStatementYear: Yup.string()
      .required("Year is required")
      .matches(/^\d{4}$/, "Year must be in YYYY format"),
    statements: Yup.array()
      .of(
        Yup.object().shape({
          year: Yup.string()
            .required("Year is required")
            .matches(/^\d{4}$/, "Year must be in YYYY format"),
          isNotAvailable: Yup.boolean(),
          yearOfStatement: Yup.string().when("isNotAvailable", {
            is: true,
            then: Yup.string().nullable(),
            otherwise: Yup.string()
              .required("Date of this statement is required")
              .matches(
                /^\d{4}\/\d{2}\/\d{2}$/,
                "Date must be in YYYY/MM/DD format"
              ),
          }),
          boardApprovalDate: Yup.string().when("isNotAvailable", {
            is: true,
            then: Yup.string().nullable(),
            otherwise: Yup.string()
              .required("Date of board approval is required")
              .matches(
                /^\d{4}\/\d{2}\/\d{2}$/,
                "Date must be in YYYY/MM/DD format"
              ),
          }),
          auditorApprovalDate: Yup.string().when("isNotAvailable", {
            is: true,
            then: Yup.string().nullable(),
            otherwise: Yup.string()
              .required("Date of auditor approval is required")
              .matches(
                /^\d{4}\/\d{2}\/\d{2}$/,
                "Date must be in YYYY/MM/DD format"
              ),
          }),
          fileUploads: Yup.object().when("isNotAvailable", {
            is: true,
            then: Yup.object().nullable(),
            otherwise: Yup.object()
              .shape({
                financialStatements: Yup.mixed()
                  .required("Financial statements file is required")
                  .test(
                    "file-or-name",
                    "Must be a valid PDF file or a pre-existing file name",
                    (value) => {
                      if (!value) return false;
                      // Allow File objects (new uploads)
                      if (value instanceof File) {
                        return (
                          value.type === "application/pdf" &&
                          value.size <= 2097152 // 2MB limit
                        );
                      }
                      // Allow strings (pre-existing file names)
                      return (
                        typeof value === "string" && value.endsWith(".pdf")
                      );
                    }
                  ),
              })
              .required("File uploads are required")
              .nullable(),
          }),
        })
      )
      .required("At least one financial statement is required"),
  }),
});
